import React, { useState } from 'react';
import { Autocomplete, Box, Button, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './styles';
import { countryCode } from '../wifi-config/values';
import { requestSimRecredential } from './calls';
import { AppState } from '../../../store';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';
import { getSimRecredentialStatus } from '../../../store/bulk-device-flash/actions';

const SimRecredential = () => {
  const classes = useStyles();
  const [formValue, setFormValue] = useState({ country: '' });
  const [recredentialStatus, setRecredentialStatus] = useState('');
  const [lmnoValue, setLmnoValue] = useState({ lmno: '' });
  const login = useSelector((state: AppState) => state.login);
  const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);

  const dispatch = useDispatch();

  const snackbarCallback = ({ message, variant }: { message: string; variant: string }) => {
    dispatch(
      enqueueSnackbarAction({
        message,
        options: {
          variant,
        },
      }),
    );
  };

  const handleChange = (value: string, key: string) => {
    if (key.startsWith('country')) {
      setFormValue({ ...formValue, [key]: value });
    } else {
      setLmnoValue({ ...lmnoValue, [key]: value });
    }
  };

  const handleSubmit = async () => {
    const simCredParameters = formValue?.country.startsWith('No selection') ? lmnoValue : formValue;
    await requestSimRecredential({
      login,
      selectedEntity,
      simCredentialParams: simCredParameters,
      snackbarCallback,
    });
  };
  const handleGetStatus = async () => {
    setRecredentialStatus('');
    const statuses: any = await dispatch(getSimRecredentialStatus());
    const latestStatus = statuses.data?.devices
      .filter((device: any) => device.recredentialStatus)
      .sort((a: any, b: any) => new Date(a.lastUpdatedTime).getTime() < new Date(b.lastUpdatedTime).getTime() ? 1 : -1);
    setRecredentialStatus(latestStatus?.length ? latestStatus[0].recredentialStatus : '');
  }

  const disableButton = () => {
    if (formValue?.country.startsWith('No selection') && !lmnoValue?.lmno) {
      return true;
    }
    if (!formValue?.country) {
      return true;
    }
    return false;
  }

  return (
    <>
      <Grid container xs={12}>
        <Grid item xs={6} md={4} className={classes.inputWrapper}>
          <Typography variant="h6">Country:</Typography>
          <Box className={classes.inputContainer}>
            <Autocomplete
              id="dataCountry"
              options={countryCode}
              className={classes.select}
              renderInput={(parameters) => <TextField variant="standard" {...parameters} />}
              onChange={(event, newValue) => {
                if (newValue) {
                  handleChange(newValue.value, 'country');
                }
                else {
                  setFormValue({ country: '' })
                }
              }}
            />
          </Box>
        </Grid>
        {formValue.country === "No selection" && (
          <Grid item xs={6} md={4} className={classes.inputWrapper}>
            <Typography variant="h6">
              LMNO:
            </Typography>
            <Box className={classes.inputContainer}>
              <TextField
                variant="standard"
                className={classes.fullWidth}
                value={lmnoValue.lmno}
                onChange={(event) => handleChange(event.target.value as string, "lmno")}
              />
            </Box>
          </Grid>
        )}

        <Grid item xs={6} md={4}>
          <Button id="submit" onClick={handleSubmit} variant="outlined" size="small" color="primary"
            disabled={disableButton()}
          >
            Update Device Sim
          </Button>
        </Grid>
      </Grid>
      <Grid container xs={12} pt={2}>
        <Grid item xs={6} md={4} className={classes.inputWrapper}>
          <Typography variant="h6">Recredential Status:</Typography>
          {recredentialStatus}
        </Grid>
        <Grid item xs={6} md={4}>
          <Button onClick={handleGetStatus} variant="outlined">Get Recredential status</Button>
        </Grid>
      </Grid>
    </>
  );
};

export default SimRecredential;
